<template>
  <div class="chat-launcher">
    <!-- 在线聊消息 -->
    <div @click="handleClickChat" class="chat-icon">
      <div class="badge" v-if="msgUnreadCount">{{msgUnreadCount}}</div>
    </div>
    <!-- 在线聊列表 -->
    <transition name="el-fade-in-linear">
      <div :style="{height: innerHeight+'px'}" class="chat-list" v-if="isShowList">
        <div class="head">
          <div class="icon"></div>
          <div class="text">在线聊</div>
          <div @click="handleCloseList" class="close"></div>
        </div>
        <div class="list">
          <div :class="{'active': index === current}" :key="index" @click="handleClickItem(index,item)" class="item"
            v-for="(item,index) in conversationList">
            <div v-if="userInfo.type === 2" class="avatar">
              <img v-if="item._attributes.roomInfo.seeker.avatar" :src="item._attributes.roomInfo.seeker.avatar" />
              <img v-else src="../assets/images/img_user_default.svg" />
              <!-- <div class="status online"></div> -->
              <!-- <div class="status outline"></div> -->
            </div>
            <div class="content">
              <div class="name-row">
                <div class="name">
                  <span class="title">{{userInfo.type === 1 ? item.name : item._attributes.roomInfo.seeker.name}}</span>
                  <span class="badge" v-if="item.unreadMessagesCount && item !== currentConversation">{{item.unreadMessagesCount}}</span>
                </div>
                <div class="time" v-if="item.lastMessageAt">{{item.lastMessageAt | timeago}}</div>
              </div>
              <div class="msg-row" v-if="item.lastMessage">{{item.lastMessage.text}}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 在线聊窗口 -->
    <transition name="el-fade-in">
      <div :class="{'trsf': !isShowList}" :style="{height: innerHeight+'px'}" class="chat-room" v-if="isShowRoom && currentConversation">
        <div class="head-box">
          <div>与{{currentConversation._attributes.roomInfo.seeker.name}}在线聊</div>
          <div :class="['status',onlineStatus ? 'online' : 'outline']" v-if="onlineStatus !== null">{{onlineStatus?
            '在线' : '离线'}}</div>
          <!-- <div class="status outline">离线</div> -->
          <div @click="handleCloseRoom" class="close"></div>
        </div>
        <div class="msg-box" id="msgBox" ref="msgBox">
          <!-- 职位描述 -->
          <!-- <div class="job-info">
            <div class="til">
              <div class="name">美食亲子电商销售经理（双休+五险一金等）</div>
              <div class="pay">5k-8k</div>
            </div>
            <div class="company">滁州宏禧木业有限公司</div>
            <div class="rule">
              <div class="rule-item">滁州市</div>
              <div class="rule-item">滁州市</div>
            </div>
          </div> -->
          <div :class="{'active': index === current}" :key="index" class="item" v-for="(item,index) in chatMessages">
            <message :roomInfo="currentConversation._attributes.roomInfo" :message="item" :previous-message="chatMessages[index - 1]"
              :next-message="chatMessages[index + 1]" :isMine="item.from === imClient.id" />
          </div>
        </div>
        <!-- 发送消息部分 -->
        <div class="footer">
          <!-- 输入框 -->
          <div class="input-box">
            <button @click="handleClickUsal" class="common-btn">常用语</button>
            <div class="remind">按回车直接发送</div>
            <button @click="sendMsg" class="send-btn" :disabled="!inputValue">发送</button>
            <textarea class="input" contenteditable="true" placeholder="请输入消息内容" v-model="inputValue" @keyup.enter="sendMsg"></textarea>
          </div>
          <!-- 常用语 -->
          <transition name="el-fade-in">
            <div class="usually-box" v-show="isShowUsalBox">
              <div :key="index" @click="handleChoose(item)" class="item" v-for="(item, index) in usalData">{{item}}</div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import { Realtime, TextMessage, Event } from 'leancloud-realtime';
// 状态
import { mapState, mapGetters } from 'vuex';
import Message from './Message';

const realtime = new Realtime({
  appId: '8uc1XpnexhCHipnFod7S9VXV-gzGzoHsz',
  appKey: 'MVpIq9MxYpr3GLhE3DkHYvSm',
  server: {
    api: 'avoscloud.com',
    RTMRouter: 'router-g0-push.avoscloud.com'
  }
});

export default {
  name: 'ChatPopup',
  components: {
    Message
  },
  data() {
    return {
      // 输入内容
      inputValue: '',
      // 是否显示常用语
      isShowUsalBox: false,
      // 是否显示好友列表
      isShowList: false,
      // 是否显示聊天窗口
      isShowRoom: false,
      // 选中聊天对象
      current: '',
      // 页面可用高度
      innerHeight: '',
      usalData: ['您好，请问您对哪个职位感兴趣？'],
      imClient: null,
      conversationList: [],
      chatMessages: [],
      currentConversation: null,
      msgUnreadCount: 0,
      onlineStatus: null,
      lastSendTime: null
    };
  },
  computed: mapState({
    ...mapGetters({ userInfo: 'user' })
  }),
  watch: {
    userInfo(newVal) {
      if (this.imClient === null) {
        this.initLCRT();
      }
    },
    chatMessages() {
      this.$nextTick(() => {
        if (!this.isShowRoom) return;
        let list = this.$refs.msgBox;
        list.scrollTop = list.scrollHeight;
        this.currentConversation.read();
      });
    }
  },
  mounted() {
    this.$set(this, 'innerHeight', window.innerHeight);
    const updateHeight = () => {
      const headHeight = window.outerHeight - window.innerHeight;
      const currentHeight = window.outerHeight - headHeight;
      this.innerHeight = currentHeight;
    };
    window.onresize = _.throttle(updateHeight, 150);
  },
  methods: {
    getConvTarget(members) {
      if (members[0] === this.imClient.id) {
        return members[1];
      }
      return members[0];
    },
    // 点击在线聊
    handleClickChat() {
      this.handleShowList();
    },
    // 选择聊天对象
    handleClickItem(index, conversation) {
      if (this.current === index && this.isShowRoom) return;
      this.$set(this, 'current', index);
      this.handleShowRoom(conversation);
    },
    // 选择常用语
    handleChoose(item) {
      this.$set(this, 'inputValue', item);
      this.$set(this, 'isShowUsalBox', false);
    },
    // 点击常用语按钮
    handleClickUsal() {
      this.$set(this, 'isShowUsalBox', !this.isShowUsalBox);
    },
    // 关闭列表
    handleCloseList() {
      this.$set(this, 'isShowList', false);
    },
    // 关闭聊天窗口
    handleCloseRoom() {
      document.body.style.overflow = '';
      this.$set(this, 'isShowRoom', false);
      this.currentConversation = null;
      this.chatMessages = [];
      this.onlineStatus = null;
    },
    // 显示列表
    handleShowList() {
      this.$set(this, 'isShowList', true);
    },
    // 显示聊天窗口
    handleShowRoom(conversation) {
      document.body.style.overflow = 'hidden';
      this.$set(this, 'isShowRoom', true);
      this.$set(this, 'currentConversation', conversation);
      this.queryMessages(conversation);
      this.checkOnlineStatus(this.getConvTarget(conversation.members));
    },
    // 初始化 imClient 实例
    initLCRT() {
      const _this = this;
      realtime
        .createIMClient(`${this.userInfo.pid}`)
        .then(async imClient => {
          _this.imClient = imClient;
          _this.queryConversation();
          imClient.on(Event.MESSAGE, message => {
            if (this.currentConversation && message.cid === this.currentConversation.id) {
              _this.chatMessages.push(message);
            } else {
              _this.queryConversation();
            }
          });
          imClient.on(Event.UNREAD_MESSAGES_COUNT_UPDATE, () => {
            _this.queryUnreadMsgCount(imClient.id);
          });
        })
        .catch(console.error);
    },
    // 查询聊天室历史消息（后台接口支持查询指定的聊天室未读消息）
    queryMessages(conversation) {
      conversation
        .queryMessages({
          limit: 10 // limit 取值范围 1~1000，默认 100
        })
        .then(messages => {
          // 最新的十条消息，按时间增序排列
          this.chatMessages = messages;
        })
        .catch(console.error.bind(console));
    },
    // 查询用户未读消息
    queryUnreadMsgCount(clientId) {
      this.$api.realtime.getUnreadCount({ client_id: clientId }).then(res => {
        this.msgUnreadCount = res.count;
      });
    },
    // 查询用户在线状态
    checkOnlineStatus(clientId) {
      this.$api.realtime.checkOnlineStatus({ client_id: clientId }).then(res => {
        this.onlineStatus = res.online;
      });
    },
    async initConversation() {
      this.currentRoom = await this.imClient.createConversation({
        members: ['ab649d6f93ce4f49b65339b50345ef51'],
        name: `ab649d6f93ce4f49b65339b50345ef51 & ${this.userInfo.pid}`,
        unique: true,
        roomInfo: {
          type: 1, // 在线聊
          seekerId: 'ab649d6f93ce4f49b65339b50345ef51',
          hunterId: this.userInfo.pid,
          memberInfo: {
            [this.userInfo.pid]: {
              id: this.userInfo.id,
              pid: this.userInfo.pid,
              username: this.userInfo.username,
              avatar: this.userInfo.avatar || this.userInfo.headimgurl || ''
            },
            ab649d6f93ce4f49b65339b50345ef51: {
              id: 874697,
              pid: 'ab649d6f93ce4f49b65339b50345ef51',
              username: ' liusongg',
              avatar: ''
            }
          }
        }
      });
      this.currentRoom.send(new TextMessage('刘松你好'));
    },
    // 查询用户聊天室列表
    queryConversation() {
      const _this = this;
      this.imClient
        .getQuery()
        .withLastMessagesRefreshed()
        .containsMembers([`${this.imClient.id}`])
        .find()
        .then(conversations => {
          // console.log(conversations);
          _this.conversationList = conversations;
        })
        .catch(console.error.bind(console));
    },
    /**
     * 发送微信服务号通知
     */
    async sendWechatNotice(params) {
      try {
        const res = await this.$api.message.sendChatMessage(params);
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    },
    sendMsg() {
      const msgText = this.inputValue.trim();
      if (!msgText) return;
      const msg = new TextMessage(msgText);
      this.currentConversation.send(msg);
      this.chatMessages.push(msg);
      this.inputValue = '';

      // 如果对方不在线，则由微信服务号发送消息通知
      if (!this.onlineStatus) {
        const curTimestamp = parseInt(new Date().getTime() / 1000);
        const timestampDiff = curTimestamp - this.lastSendTime;
        if (!this.lastSendTime || timestampDiff > 60) {
          this.lastSendTime = parseInt(new Date().getTime() / 1000);
          this.$notify.warning({
            title: '提示',
            message: '对方不在线，您的消息已通过微信发送通知。',
            showClose: false,
            duration: 3e3
          });
          this.sendWechatNotice({
            toPid: this.currentConversation.members.find(item => item !== this.userInfo.pid),
            room_id: this.currentConversation.id,
            content: msgText
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@imgUrl: '../assets/images/enterprise-center';
.font (@size, @weight, @color, @lineHeight) {
  font-size: @size;
  font-weight: @weight;
  color: @color;
  line-height: @lineHeight;
}
@keyframes close {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(280px);
  }
}
.trsf {
  animation: close 0.2s ease-in forwards;
}
.chat-icon {
  position: fixed;
  right: 40px;
  bottom: 80px;
  width: 50px;
  height: 50px;
  background: url('@{imgUrl}/recruit_chat.png') no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 999;

  .badge {
    position: absolute;
    right: -10px;
    top: -1px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #fff;
    padding: 0 5px;
    background: rgba(255, 0, 0, 1);
    border-radius: 35px;
    border: 1px solid #fff;
  }
}
.chat-room {
  position: fixed;
  bottom: 0;
  right: 280px;
  width: 580px;
  max-height: 775px;
  background: rgba(245, 245, 245, 1);
  box-shadow: -10px 10px 10px 0px rgba(0, 0, 0, 0.1);
  border-top: 3px solid #ffb916;
  z-index: 999;
  .head-box {
    .font(16px, 500, rgba(51, 51, 51, 1), 16px);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 580px;
    height: 50px;
    background: rgba(253, 253, 253, 1);
    padding: 0 20px;
    .status {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 16px;
      border-radius: 8px;
      margin-left: 10px;
    }
    .online {
      .font(12px, 400, #fff, 12px);
      background: rgba(102, 204, 86, 1);
    }
    .outline {
      .font(12px, 400, #fff, 12px);
      background: rgba(179, 184, 186, 1);
    }
    .close {
      position: absolute;
      right: 10px;
      width: 12px;
      height: 12px;
      background: url('@{imgUrl}/chat_close.png') no-repeat center;
      background-size: 100% 100%;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .msg-box {
    height: calc(100% - 190px);
    padding: 20px 20px 0 20px;
    margin-top: 50px;
    overflow-y: auto;
    // 职位描述
    .job-info {
      width: 540px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid rgba(233, 233, 233, 1);
      margin: 0 auto;
      padding: 20px;
      margin-bottom: 20px;
      .til {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          .font(14px, 500, rgba(51, 51, 51, 1), 20px);
          width: 350px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .pay {
          .font(14px, 600, rgba(255, 81, 89, 1), 20px);
        }
      }
      .company {
        .font(14px, 400, rgba(102, 102, 102, 1), 20px);
        margin-top: 6px;
      }
      .rule {
        display: flex;
        .rule-item {
          .font(12px, 400, rgba(102, 102, 102, 1), 12px);
          padding: 5px;
          background: rgba(248, 248, 248, 1);
          margin-top: 8px;
          &:not(:last-child) {
            margin-right: 6px;
          }
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 580px;
    height: 140px;
    padding: 12px 20px 10px 20px;
    border-top: 1px solid #dcdcdc;
    .input-box {
      position: relative;
      width: 100%;
      height: 100%;
      padding-bottom: 35px;
      .input {
        border: none;
        outline: none;
        bottom: 0;
        left: 0;
        color: #666;
        resize: none;
        border: 0;
        -webkit-transition: background-color ease 200ms, -webkit-box-shadow ease 200ms;
        transition: background-color ease 200ms, box-shadow ease 200ms;
        transition: background-color ease 200ms, box-shadow ease 200ms, -webkit-box-shadow ease 200ms;
        box-sizing: border-box;
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.33;
        background-color: #f5f5f5;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
      .common-btn {
        .font(14px, 400, #fff, 14px);
        position: absolute;
        bottom: 0;
        left: 0;
        width: 56px;
        height: 26px;
        border: none;
        background: rgba(109, 161, 255, 1);
        border-radius: 4px;
      }
      .remind {
        .font(12px, 400, rgba(204, 204, 204, 1), 12px);
        position: absolute;
        bottom: 4px;
        right: 66px;
        color: rgba(204, 204, 204, 1);
        line-height: 17px;
      }
      .send-btn {
        .font(14px, 400, #fff, 14px);
        position: absolute;
        bottom: 0;
        right: 0;
        border: none;
        width: 56px;
        height: 26px;
        background: #6da1ff;
        border-radius: 4px;
        &[disabled] {
          .font(14px, 400, #999, 14px);
          background: #fff;
          cursor: not-allowed;
        }
      }
    }
    .usually-box {
      position: absolute;
      bottom: 45px;
      left: 20px;
      width: 470px;
      background: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 10px 20px;
      .item {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
        padding: 10px 0;
        &:not(:last-child) {
          border-bottom: 1px solid #f5f5f5;
        }
      }
    }
  }
}
.chat-list {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 280px;
  max-height: 775px;
  background: rgba(253, 253, 253, 1);
  box-shadow: -1px 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-top: 3px solid #ffb916;
  border-left: 1px solid #dcdcdc;
  z-index: 999;
  .head {
    position: absolute;
    top: 0px;
    right: 0;
    display: flex;
    align-items: center;
    width: 279px;
    height: 50px;
    background: rgba(248, 248, 248, 1);
    padding: 0 20px;
    .icon {
      width: 20px;
      height: 20px;
      background: url('@{imgUrl}/recruit_chat.png') no-repeat center;
      background-size: 100% 100%;
      margin-right: 10px;
    }
    .text {
      .font(16px, 500, rgba(51, 51, 51, 1), 16px);
    }
    .close {
      position: absolute;
      right: 0;
      width: 12px;
      height: 12px;
      background: url('@{imgUrl}/chat_close.png') no-repeat center;
      background-size: 100% 100%;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .list {
    height: calc(100% - 50px);
    margin-top: 50px;
    overflow-y: auto;
    .active {
      background: rgba(248, 248, 248, 1) !important;
    }
    .item {
      display: flex;
      align-items: center;
      padding: 17px 20px;
      border-bottom: 1px solid #e9e9e9;
      background: #fff;
      cursor: pointer;
      &:first-of-type {
        border-top: 1px solid #e9e9e9;
      }
      .avatar {
        position: relative;
        width: 40px;
        height: 40px;
        background-size: 100% 100%;
        border-radius: 50%;
        margin-right: 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
        .status {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          border: 1px solid #fff;
        }
        .online {
          background: rgba(66, 219, 42, 1);
        }
        .outline {
          background: rgba(179, 184, 186, 1);
        }
      }
      .content {
        flex: 1;
        width: 0;
        height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
          .name {
            .font(14px, 400, rgba(44, 48, 54, 1), 20px);
            display: flex;
            align-items: center;
            .title {
              display: block;
              max-width: 80px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .badge {
              .font(12px, 500, #fff, 16px);
              display: inline-block;
              padding: 0 4px;
              height: 16px;
              min-width: 16px;
              background: rgba(255, 0, 0, 1);
              border-radius: 8px;
              margin-left: 10px;
              text-align: center;
              -webkit-font-smoothing: antialiased;
            }
          }
          .time {
            .font(12px, 400, rgba(151, 151, 153, 1), 17px);
          }
        }
        .msg-row {
          .font(12px, 400, rgba(112, 112, 118, 1), 17px);
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatPopup.vue